import {GUID} from "../../shared/models/GUID-interface";

export class ChartVisibilityGUID implements GUID{
    constructor(public readonly GUID: string, public hideChart: boolean){
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/chart-visibility-GUID.ts